import { API } from 'aws-amplify';
import { GlobalValue } from '../data_types/global-value';
import { getAuthHeaders } from './auth';

export type EntityType = 'countries' | 'career-types';

const getEntities = async (entity: EntityType): Promise<GlobalValue[]> => {
    const response = await API.get('membership', `/${entity}`, {
        headers: getAuthHeaders(),
    });

    return response.data;
};

export default getEntities;
